export default __webpack_public_path__ + "static/media/Amazon.dec14206.png";